export default "__VITE_ASSET__CrXI1zW3__"